<template>
  <v-card
    class="mx-auto"
    max-width="1000"
  >
    <v-system-bar
      color="indigo darken-2"
      dark
    >
      <v-spacer></v-spacer>

    </v-system-bar>

    <v-toolbar
      color="indigo"
      dark
    >

      <v-toolbar-title>Meet our team members</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon>
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </v-toolbar>

    <v-container fluid>
      <v-row dense>
        <v-col
          v-for="card in cards"
          :key="card.name"
          :cols="card.flex"
        >
          <v-card>
            <v-img
              :src="card.src"
              class="white--text align-end"
              gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              height="500px"
            >
              <v-card-title
              v-text="card.name"
              class="text-h5"
              >
              </v-card-title>
            </v-img>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
              icon
              :to="{name: 'UserProfile'}"
              >
                <v-icon>mdi-cursor-default-click</v-icon>
              </v-btn>

              <v-btn icon>
                <v-icon>mdi-share-variant</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
  export default {
    data: () => ({
      cards: [
        { name: 'John Faker', src: 'https://www.valpo.edu/esports/files/2021/02/20210206-JLH-Esports-Portraits-007.jpg', flex: 6 },
        { name: 'JJoNak', src: 'https://www.valpo.edu/esports/files/2021/02/20210206-JLH-Esports-Portraits-004.jpg', flex: 6 },
        { name: 'Seagull', src: 'https://www.valpo.edu/esports/files/2021/02/20210206-JLH-Esports-Portraits-029.jpg', flex: 6 },
        { name: 'spirit_moon ', src: 'https://www.valpo.edu/esports/files/2021/02/20210206-JLH-Esports-Portraits-023.jpg', flex: 6 },
      ],
    }),
  }
</script>

<style scoped>
.flex-container {
  /* We first create a flex layout context */
  display: flex;

  /* Then we define the flow direction
     and if we allow the items to wrap
   * Remember this is the same as:
   * flex-direction: row;
   * flex-wrap: wrap;
   */
  flex-flow: row wrap;

  /* Then we define how is distributed the remaining space */
  justify-content: space-around;

  padding: 0;
  margin: 0;
  list-style: none;
}

.flex-item {
  background: primary;
  padding: 5px;
  width: 200px;
  height: 150px;
  margin-top: 10px;
  line-height: 150px;
  color: secondary;
  font-weight: bold;
  font-size: 3em;
  text-align: center;
}
</style>
